import {cUtil}                    from '../../../functions/util';
import { cProductItem }           from '../../../components/product-item/product-item';
import {cSingleProductOrderList}  from './single-product-order-list';

export class cSingleProductOrderLists {

  section_orderList   = document.createElement('section');
  header              = document.createElement('header');
  h2                  = document.createElement('h2');
  button_close        = document.createElement('button');
  fieldset_newList    = document.createElement('fieldset');
  input_newList       = document.createElement('input');
  button_newList      = document.createElement('button');
  button_newListSmall = document.createElement('button');
  div_newList_error   = document.createElement('div');
  div_lists           = document.createElement('div');
  div_spinner         = document.createElement('div');
  span_spinner        = document.createElement('span');
  footer              = document.createElement('footer');
  button_closeEnd     = document.createElement('button');

  nonce       : string;
  customerId  : string;
  productItem : cProductItem;
  listItems   : cSingleProductOrderList[];

  constructor(
    customerId    : string,
    lists         : OrderList[],   // Available order lists
    nonce         : string,
    parent        : HTMLElement,
    productItem   : cProductItem,  // Input data from single product
  ) {

    this.nonce         = nonce;
    this.customerId    = customerId;
    this.productItem   = productItem;
    this.listItems     = [];

    // ---- Structure ----
    parent.append(this.section_orderList);
      this.section_orderList.append(this.div_spinner);
        this.div_spinner.append(this.span_spinner);
      this.section_orderList.append(this.header);
        this.header.append(this.h2);
        this.header.append(this.button_close);      
      this.section_orderList.append(this.div_lists);
        this.div_lists.append(this.fieldset_newList);
          this.fieldset_newList.append(this.input_newList);
          this.fieldset_newList.append(this.button_newList);
          this.fieldset_newList.append(this.button_newListSmall);
          this.fieldset_newList.append(this.div_newList_error);
        
          for(const list of lists) {
            const orderList = new cSingleProductOrderList(
              list, 
              this.div_lists, 
              nonce,
              productItem, 
              this
            );
            this.listItems.push(orderList);
          }

      this.section_orderList.append(this.footer);
        this.footer.append(this.button_closeEnd);

    // ---- Texts ----
    const { __, _x, _n, sprintf }   = wp.i18n as i18n;
    this.h2.innerText               = productItem.inputData.product.name + ' | ' + __('Zur Bestellliste hinzufügen', 'custom');
    this.input_newList.placeholder  = __('Neue Bestellliste', 'custom');
    this.button_newList.innerText   = __('Hinzufügen', 'custom');
    this.button_closeEnd.innerText  = __('Schliessen', 'custom');

    // ---- Classes ----
    this.section_orderList   .classList.add('c-single-product-order-list');
    this.button_newList      .classList.add('c-button');
    this.button_newListSmall .classList.add('c-button-icon');
    this.button_close        .classList.add('c-button-icon');
    this.button_closeEnd     .classList.add('c-button-simple-light')

    //  ---- Other ----
    this.input_newList.maxLength  = 200;
    this.input_newList.type       = 'text';
    this.button_close.type        = 'button';
    this.button_newList.type      = 'button';
    this.button_newListSmall.type = 'button';
    this.button_closeEnd.type     = 'button';

    // ---- Events ----
    this.button_close.addEventListener('click', () => {
      this.close();
    });

    this.button_closeEnd.addEventListener('click', () => {
      this.close();
    });

    this.button_newList.addEventListener('click', (e) => {
      e.stopPropagation();
      this.addNewList();
    });
    this.button_newListSmall.addEventListener('click', (e) => {
      e.stopPropagation();
      this.addNewList();
    });

    this.input_newList.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    });

    // ---- Init ----
    this.section_orderList.classList.add('c-hidden');
    this.div_newList_error.classList.add('c-hidden');
    this.spinnerOff();
    this.button_close.focus();
  }

  open() {
    this.section_orderList.classList.remove('c-hidden');
    this.button_close.focus();
  }
  close() {
    this.div_newList_error.classList.add('c-hidden');
    this.input_newList.classList.remove('c--error-marker');
    this.section_orderList.classList.add('c-hidden');
    this.input_newList.value = '';
  }
  spinnerOn() {
    this.div_spinner.classList.remove('c-hidden');
    this.section_orderList.classList.add('c-overflow-hidden');
  }
  spinnerOff() {
    this.div_spinner.classList.add('c-hidden');
    this.section_orderList.classList.remove('c-overflow-hidden');
  }

  async addNewList() {
    const { __, _x, _n, sprintf }  = wp.i18n as i18n;

    if (this.input_newList.value === '') {
      this.div_newList_error.innerText = __('Keine gültige Eingabe', 'custom');
      this.div_newList_error.classList.remove('c-hidden');
      this.input_newList.classList.add('c--error-marker');
      return;
    }
    this.div_newList_error.classList.add('c-hidden');
    this.input_newList.classList.remove('c--error-marker');
    this.spinnerOn();

    const listId = cUtil.rand();
    const list: OrderList = {
      customer_id     : this.customerId,
      list_id         : listId,
      name            : this.input_newList.value,
      delivery_date   : '',
      tag             : '',
      valid_from      : '',
      valid_to        : '',
    };
    await this.send(list, 'c_order_list_add');

    const item       = this.productItem.getData();
    item.list_id     = listId;
    item.customer_id = this.customerId;
    await this.send(item,  'c_order_list_item_add');

    const itemLocal = new cSingleProductOrderList(
      list,
      this.div_lists, 
      this.nonce,
      this.productItem, 
      this,
    );
    this.listItems.push(itemLocal);

    this.input_newList.value = '';
    this.close();
    this.spinnerOff()
  }


  async send(data: OrderList  | OrderListItem, action: string) {
    const  formData = new FormData();
    formData.append('_ajax_nonce', this.nonce);
    formData.append('action'     , action);
    formData.append('data'       , JSON.stringify(data));

    const error = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    });
    return error;
  }
}
